import ArrayUtils from '@/utils/arrayUtils'

export default
{
    namespaced: true,
    
    state:
    {
        notificationList: []
    },

    getters:
    {
        getNotificationsByStoreId: state => id =>
        {
            return state.notificationList.filter(e => e.storeId == id)
        }
    },

    mutations:
    {
        setNotificationList (state, notifications)
        {
            state.notificationList = notifications
        },

        updateNotificationList (state, notifications) 
        {
            var merged = ArrayUtils.mergeArrays(state.notificationList, notifications, (a, b) => a.id == b.id)
            
            merged = merged.sort((a, b) =>
            {
                if (a.isUncreated) return -Infinity

                let dDate = new Date(b.date) - new Date(a.date)
                let dId = b.id - a.id

                return dDate + dId
            })

            state.notificationList = merged
        }
    },

    actions:
    {
    }
}


// WEBPACK FOOTER //
// ./src/stores/storeNotifications.js